var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "viewBox": "0 0 200 200",
      "width": "200",
      "height": "200",
      "xmlns": "http://www.w3.org/2000/svg",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "100",
      "fill": "#2196F3"
    }
  }), _c('path', {
    attrs: {
      "d": "M200 100c0 55.2-44.8 100-100 100V0c36.4 0 68.4 19.5 85.9 48.6C194.3 62.8 200 80.8 200 100z",
      "fill": "#1D7FCE"
    }
  }), _c('rect', {
    attrs: {
      "x": "52",
      "y": "46",
      "width": "96",
      "height": "122",
      "rx": "14",
      "fill": "#2A3B4F"
    }
  }), _c('rect', {
    attrs: {
      "x": "80",
      "y": "34",
      "width": "40",
      "height": "24",
      "rx": "7",
      "fill": "#FFC61B"
    }
  }), _c('rect', {
    attrs: {
      "x": "92",
      "y": "38",
      "width": "16",
      "height": "12",
      "rx": "3",
      "fill": "#F4B400"
    }
  }), _c('rect', {
    attrs: {
      "x": "60",
      "y": "58",
      "width": "80",
      "height": "100",
      "rx": "10",
      "fill": "#FFF6D6"
    }
  }), _c('rect', {
    attrs: {
      "x": "72",
      "y": "74",
      "width": "18",
      "height": "18",
      "rx": "5",
      "fill": "#FFC61B"
    }
  }), _c('path', {
    attrs: {
      "d": "M76 83l5 5 9-10",
      "fill": "none",
      "stroke": "#2A3B4F",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('rect', {
    attrs: {
      "x": "98",
      "y": "80",
      "width": "30",
      "height": "6",
      "rx": "3",
      "fill": "#2A3B4F",
      "opacity": "0.22"
    }
  }), _c('rect', {
    attrs: {
      "x": "72",
      "y": "102",
      "width": "18",
      "height": "18",
      "rx": "5",
      "fill": "#2A3B4F",
      "opacity": "0.18"
    }
  }), _c('rect', {
    attrs: {
      "x": "98",
      "y": "108",
      "width": "26",
      "height": "6",
      "rx": "3",
      "fill": "#2A3B4F",
      "opacity": "0.16"
    }
  }), _c('rect', {
    attrs: {
      "x": "72",
      "y": "130",
      "width": "18",
      "height": "18",
      "rx": "5",
      "fill": "#2A3B4F",
      "opacity": "0.12"
    }
  }), _c('rect', {
    attrs: {
      "x": "98",
      "y": "136",
      "width": "22",
      "height": "6",
      "rx": "3",
      "fill": "#2A3B4F",
      "opacity": "0.12"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }